<template>
  <tr v-for="configuration,index in group" :key="index">
    <td>
      {{ inEnglish ? configuration.booth_refinement.name_en : configuration.booth_refinement.name }}
    </td>
    <template v-if="index === 0">
      <td :rowspan="group.length">
        <span class="text-primary cursor--pointer" @click="show">
          <i class="fa fa-info-circle"></i> {{ articleName }}
        </span>
      </td>
    </template>
    <td v-if="false && printArticle" class="text-right">
      {{ $filters.formatMoney(printArticle.print_inclusive ? 0.00 : printArticle.exhibitionPrices.price_net) }}
    </td>
    <template v-if="index === 0">
      <td v-if="configuration.is_logo_print" :rowspan="group.length">
        <span v-if="configuration.file">
          {{ configuration.file.original_name}}
        </span>
        <span v-else>
          <i>{{ $t('configurator.labels.upload_missing') }}</i>
        </span>
      </td>
      <td v-else :rowspan="group.length">
        {{  configuration.label }}
      </td>
      <td :rowspan="group.length">
        <span class="text-primary cursor--pointer" @click="deleteConfiguration">
          <i class="fa fa-trash"></i> {{ $t('configurator.buttons.delete') }}
        </span>
      </td>
    </template>
  </tr>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'

const store = useMainStore()
// define props
const props = defineProps({
  group: {
    type: Array,
    required: true
  }
})
// define emits
const emit = defineEmits(['show'])
// define computed props
const locale = computed(() => store.settings.locale)
const shoppingCart = computed(() => store.settings.shopping_cart)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const name = computed(() => {
  return (inEnglish.value)
    ? props.configuration.booth_refinement.name_en
    : props.configuration.booth_refinement.name
})

const printArticle = computed(() => {
  const index = shoppingCart.value.print_items.findIndex((article) => {
    return article.booth_refinement_id === props.group[0].id
  })

  if (index > -1) {
    return shoppingCart.value.print_items[index]
  }

  return null
})

const articleName = computed(() => {
  if (printArticle.value === null) {
    return ''
  }

  return (inEnglish.value)
    ? printArticle.value.name_en
    : printArticle.value.name
})
// define methods
const deleteConfiguration = () => {
  props.group.forEach((configuration) => {
    shoppingCart.value.removeBoothConfiguration(configuration.id)
    shoppingCart.value.removeBoothRefinementArticle(configuration.booth_refinement.id)
  })
}

const show = () => {
  emit('show', printArticle.value)
}
</script>